const newUpgrade = {icon: 'mdi-arrow-up-thin', color: 'light-blue', effect: [{name: 'hordeBattlePassUpgrade', type: 'text', value: true}]};
const newPrestigeUpgrade = {icon: 'mdi-arrow-up-bold', color: 'orange', effect: [{name: 'hordeBattlePassPrestigeUpgrade', type: 'text', value: true}]};

export default {
    1: newUpgrade,
    2: {icon: 'mdi-bow-arrow', color: 'light-green', effect: [{name: 'hordeClassArcher', type: 'unlock', value: true}]},
    3: newUpgrade,
    5: {icon: 'mdi-wizard-hat', color: 'deep-purple', effect: [{name: 'hordeClassMage', type: 'unlock', value: true}]},
    7: newPrestigeUpgrade,
    8: newUpgrade,
    10: newPrestigeUpgrade,
    12: newPrestigeUpgrade,
    14: newUpgrade,
    15: {icon: 'mdi-shield', color: 'blue-grey', effect: [{name: 'hordeClassKnight', type: 'unlock', value: true}]},
    16: newPrestigeUpgrade,
    18: newUpgrade,
    20: newPrestigeUpgrade,
    22: newUpgrade,
    24: newUpgrade,
    25: {icon: 'mdi-cached', color: 'pink', effect: [{name: 'hordeAutocast', type: 'base', value: 1}]},
    27: newPrestigeUpgrade,
    30: {icon: 'mdi-necklace', color: 'cyan', effect: [{name: 'hordeHeirloomAmount', type: 'mult', value: 2}]},
    31: newUpgrade,
    33: newPrestigeUpgrade,
    35: {icon: 'mdi-pirate', color: 'orange', effect: [{name: 'hordeClassPirate', type: 'unlock', value: true}]},
    40: {icon: 'mdi-star', color: 'light-blue', effect: [{name: 'hordeSkillPointsPerLevel', type: 'base', value: 1}]},
    42: newUpgrade,
    45: newPrestigeUpgrade,
    50: {icon: 'mdi-treasure-chest', color: 'red', effect: [{name: 'hordeMaxTrinkets', type: 'base', value: 1}]},
    53: newPrestigeUpgrade,
    55: newUpgrade,
    60: {icon: 'mdi-billiards-rack', color: 'teal', effect: [{name: 'hordeShardChance', type: 'mult', value: 3}]},
    65: newPrestigeUpgrade,
    66: newUpgrade,
    70: {icon: 'mdi-robber', color: 'amber', effect: [{name: 'hordeClassAssassin', type: 'unlock', value: true}]},
    75: {icon: 'mdi-treasure-chest', color: 'wooden', effect: [{name: 'hordeMaxEquipment', type: 'base', value: 1}]},
    77: newUpgrade,
    80: {icon: 'mdi-star', color: 'light-blue', effect: [{name: 'hordeSkillPointsPerLevel', type: 'base', value: 1}]},
    85: newPrestigeUpgrade,
    90: newUpgrade,
    95: {icon: 'mdi-necklace', color: 'cyan', effect: [{name: 'hordeHeirloomEffect', type: 'mult', value: 1.2}]},
    100: {icon: 'mdi-tooth', color: 'orange', effect: [{name: 'hordeMonsterToothWarzone', type: 'unlock', value: true}]},
    105: newUpgrade,
    110: {icon: 'mdi-necklace', color: 'amber', effect: [{name: 'hordeTrinketGain', type: 'mult', value: 1.5}]},
    111: newUpgrade,
    113: newPrestigeUpgrade,
    115: newUpgrade,
    120: {icon: 'mdi-pentagram', color: 'red', effect: [{name: 'hordeClassCultist', type: 'unlock', value: true}]},
    125: {icon: 'mdi-tooth', color: 'teal', effect: [{name: 'hordeMonsterToothMonkeyJungle', type: 'unlock', value: true}]},
    130: newPrestigeUpgrade,
    160: {icon: 'mdi-star', color: 'light-blue', effect: [{name: 'hordeSkillPointsPerLevel', type: 'base', value: 1}]},
    175: {icon: 'mdi-tooth', color: 'babypink', effect: [{name: 'hordeMonsterToothLoveIsland', type: 'unlock', value: true}]},
}
